import { Component, OnInit } from '@angular/core';
import { GiftsApi, ApiGiftItem } from '@tytapp/api';

@Component({
  selector: 'app-cancel-membership-success-page',
  templateUrl: './cancel-membership-success-page.component.html',
  styleUrls: ['./cancel-membership-success-page.component.scss']
})
export class CancelMembershipSuccessPageComponent implements OnInit {
  constructor(
    private readonly giftsApi: GiftsApi
  ) { }

  giftItemsLength: number = 0;

  async ngOnInit() {
    try {
      this.giftItemsLength = (await this.giftsApi.getGiftOrders().toPromise())
        .reduce((all, gift) => (all.push(...gift.gift_items), all), <ApiGiftItem[]>[])
        .filter(item => item.recurring && !item.canceled_at)
        .length;
    } catch (e) {
      console.error(`Caught error while determining outstanding gifts:`);
      console.error(e);
      this.giftItemsLength = 0;
    }
  }

}